import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { prepareFilters } from '../../../components/Filters/request';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];
  const mappedData = data.map(element => {
    return { ...element, selected: false };
  });

  mappedData.forEach(item => {
    const el = {
      key: item.created_at,
      name: item.name,
      date: item.created_at,
      status: item.status,
      query_data: item.query_data,
      fields: item.fields,
      view: item.view,
      url: item.url,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getPerformanceExports({ payload: { signal, filters, searchQ, curr_page } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.data_export.get,
      params: { page: curr_page },
      data: {
        ...prepareFilters(filters),
        q: searchQ,
        page: curr_page
      },
      signal
    });

    const preparedData = {
      next: data.next,
      previous: data.previous,
      count: data.count,
      message: data.message,
      dataTable: prepareDataTable(data.results)
    };

    yield put(actions.getPerformanceExportsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPerformanceExportsFailed,
      endpoint: api.data_export.get.url
    });
  }
}

export const getPerformanceExportsSaga = takeEvery(types.GET_PERFORMANCE_EXPORTS_REQUEST, getPerformanceExports);


